$(function () {
	$.datepicker.setDefaults(
		{
			closeText: 'Закрыть',
			prevText: '',
			currentText: 'Сегодня',
			monthNames: ['Январь','Февраль','Март','Апрель','Май','Июнь',
				'Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'],
			monthNamesShort: ['Янв','Фев','Мар','Апр','Май','Июн',
				'Июл','Авг','Сен','Окт','Ноя','Дек'],
			dayNames: ['воскресенье','понедельник','вторник','среда','четверг','пятница','суббота'],
			dayNamesShort: ['вск','пнд','втр','срд','чтв','птн','сбт'],
			dayNamesMin: ['Вс','Пн','Вт','Ср','Чт','Пт','Сб'],
			weekHeader: 'Не',
			dateFormat: 'dd MM yy',
			firstDay: 1,
			isRTL: false,
			showMonthAfterYear: false,
			yearSuffix: ''
		}
	);

	var dateToday = new Date();
	var dates = $("#from, #to").datepicker({
		defaultDate: "+1w",
		numberOfMonths: 1,
		minDate: dateToday,
		onSelect: function(selectedDate, inst) {
			var option = this.id == "from" ? "minDate" : "maxDate",
				instance = $(this).data("datepicker"),
				date = $.datepicker.parseDate(instance.settings.dateFormat || $.datepicker._defaults.dateFormat, selectedDate, instance.settings);
			dates.not(this).datepicker("option", option, date);
			if ($('#' + inst.id).val().length) {
				$(this).parent('.form__group').addClass("form__group--focus");
				$(this).parent('.form__group').removeClass('form__group--error');
			} else {
				$(this).parent('.form__group').removeClass("form__group--focus");
			}
		}
	});
});
